import React from 'react';
import { Navigate } from 'react-router-dom';

/** Ancien lien : le reset mot de passe est géré par Clerk sous /login. */
const ForgotPasswordPage: React.FC = () => <Navigate to="/login" replace />;

export default ForgotPasswordPage;
